<template>
  <div>
    <h4
      v-if="label"
      class="cf-title cf-title--4"
    >
      {{ label }}
      <span
        v-if="showAsOptional"
        class="cf-subtitle cf-subtitle--2"
      >
        (Optional)
      </span>
    </h4>

    <div
      v-if="showCustomTip"
      class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16"
    >
      <cf-text-input
        v-model="customTip"
        v-auto-focus
        type="dollars"
        label="Tip Amount"
        name="customTip"
        :allow-negative="false"
        :validations="{
          required: tipSelectionRequired
        }"
      />

      <button
        type="button"
        class="cf-button cf-button--tertiary cf-button--md"
        @click="showCustomTip = false"
      >
        View Tip Selector
      </button>
    </div>

    <div
      v-else
      class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-16"
    >
      <div class="cf-flex cf-flex--row cf-flex--justify-space-between cf-full-width">
        <button
          type="button"
          class="cf-button cf-button--secondary cf-button--fixed-48"
          title="Decrease Tip"
          @click="tipDecrease"
        >
          <span class="cf-icon cf-icon--brand-primary far fa-minus" />
        </button>

        <div class="cf-flex cf-flex--column cf-flex--align-center cf-flex--gap-8">
          <h1 class="cf-title cf-title--1">
            <template v-if="isDollarAmount">{{ $dollars(tipAmount) }}</template>
            <template v-else>Tip {{ tipAmount }}%</template>
          </h1>

          <p class="cf-subtitle cf-subtitle--2">
            <template v-if="isDollarAmount">Tip Amount</template>

            <template v-else>{{ $dollars(value) }}</template>
          </p>
        </div>

        <button
          type="button"
          class="cf-button cf-button--secondary cf-button--fixed-48"
          title="Increase Tip"
          @click="tipIncrease"
        >
          <span class="cf-icon cf-icon--brand-primary far fa-plus" />
        </button>
      </div>

      <button
        type="button"
        class="cf-button cf-button--tertiary cf-button--md"
        @click="showCustomTip = true"
      >
        Add Custom Tip
      </button>
    </div>
  </div>
</template>


<script>
  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'CfTipSelectionButton',

    components: {
      CfTextInput
    },

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    props: {
      label: {
        type: String,
        default: ''
      },

      options: {
        type: Array,
        required: true
      },

      showAsOptional: {
        type: Boolean,
        default: false
      },

      tipSelectionRequired: {
        type: Boolean,
        default: false
      },

      total: {
        type: Number,
        required: true
      },

      value: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        customTip: null,
        showCustomTip: false,
        tipAmount: 0
      };
    },

    computed: {
      defaultOption() {
        return this.options.find(option => option.isDefault) || this.options[0];
      },

      isDollarAmount() {
        return this.defaultOption && Object.prototype.hasOwnProperty.call(this.defaultOption, 'dollarAmount');
      }
    },

    watch: {
      customTip: 'tipSelectHandler',
      showCustomTip: 'tipSelectHandler',
      tipAmount: 'tipSelectHandler',
      isDollarAmount: 'selectDefaultTip',
      total: 'tipSelectHandler'
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.selectDefaultTip();
      },

      selectDefaultTip() {
        if (this.defaultOption) {
          const { dollarAmount, percentAmount } = this.defaultOption;
          this.tipAmount = this.isDollarAmount
            ? dollarAmount || 0
            : percentAmount || 0;
        }
      },

      tipDecrease() {
        if (this.tipAmount > 0) {
          if (this.isDollarAmount) this.tipAmount -= 0.5;
          else this.tipAmount -= 1;
        }
      },

      tipIncrease() {
        if (this.isDollarAmount) this.tipAmount += 0.5;
        else this.tipAmount += 1;
      },

      tipSelectHandler() {
        let tip = 0;

        if (this.showCustomTip) {
          if (this.customTip && this.isDollarAmount) this.tipAmount = this.customTip;
          tip = this.customTip;
        }

        else if (this.tipAmount) {
          if (this.isDollarAmount) {
            tip = this.tipAmount;
          }
          else {
            const percentage = this.tipAmount / 100;
            tip = Math.round((this.total * percentage) * 100) / 100;
          }
        }

        this.$emit('select', tip);
      }
    }
  };
</script>
